import ConfigManager from "@/config/ConfigManager"
import BzbsApi from "@/core/Http/BzbsApi"
import AccountHelper from "@/helper/AccountHelper"

export default {
    apiAppointmentClaim: function (policyNo, params) {
        // 001-21-2100-919453
        let url = ConfigManager.getApiModuleUrl() + `/tni/${policyNo}/claim`
        let token = AccountHelper.getToken()
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params).subscribe({
                next: (resp) => {
                    resolve(resp.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    apiGetPolicyDetail: function (policyNo) {
        let url = ConfigManager.getApiModuleUrl() + "/tni/" + policyNo + "/policy"
        let token = AccountHelper.getToken()
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, {}).subscribe({
                next: (resp) => {
                    resolve(resp.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    apiGetCustomerInfo: function () {
        let url = ConfigManager.getApiModuleUrl() + "/tni/customer_info"
        let token = AccountHelper.getToken()
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, {}).subscribe({
                next: (resp) => {
                    resolve(resp.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    apiSendMsgClaimSuccess: function (acdNo) {
        let url = ConfigManager.getApiModuleUrl() + "/line/send_message_claim_success"
        let token = AccountHelper.getToken()
        let params = {
            acdno: acdNo
        }
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params).subscribe({
                next: (resp) => {
                    console.log(resp.data)
                    resolve(resp.data)
                },
                error: (err) => {
                    console.log(err)
                    reject(err)
                }
            })
        })
    }
}